module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.db812d8a.woff2";